import { useData } from "./DataContext.js";

export default function TitlePage (props)
{
    const gData = useData();

    const bgImageSrc = gData.gameId + "/pictures/title-light.jpg";
    //const fgImageSrc = gData.gameId + "/pictures/title-chars.png";

    return (
	<>
	    <div className="vw-100 vh-100 opacity-100" style={{ backgroundImage: "url(" + bgImageSrc + ")", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "50% 50%" }}/>
	    {/* <img className="position-absolute" src={fgImageSrc} alt="Personnages principaux" style={{ width: "50%", left: "55%", top: "5%" }}/> */}
	    
	    <div className="position-absolute text-center vh-100" style={{ top: "10%", left: "10%", width: "40%" }}>
		<h1 className="text-dark text-uppercase fw-bold user-select-none" style={{ fontSize: "60px" }}>Pulple & Cie</h1>
		<h2 className="text-dark user-select-none" style={{ fontSize: "25px" }}>Un jeu de simulation d'entreprise</h2>
		{props.children}
	    </div>
	</>
    );
}

